var _rect, _rect2, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#F0E9F9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#ECECEE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.9998 30.9732C34.4577 30.9732 36.4502 28.9806 36.4502 26.5227C36.4502 24.0648 34.4577 22.0723 31.9998 22.0723C29.5419 22.0723 27.5493 24.0648 27.5493 26.5227C27.5493 28.9806 29.5419 30.9732 31.9998 30.9732Z",
    stroke: "#263238",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9442 41.9275H39.0556C40.6193 41.9275 41.8238 40.5829 41.0936 39.2002C40.0193 37.1663 37.5705 34.7383 31.9999 34.7383C26.4293 34.7383 23.9804 37.1663 22.9063 39.2002C22.176 40.5829 23.3805 41.9275 24.9442 41.9275Z",
    stroke: "#263238",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerIcon);
export default __webpack_public_path__ + "static/media/customerIcon.8358e231.svg";
export { ForwardRef as ReactComponent };